import React from "react";
import styled from "styled-components";
import {NextSeo} from "next-seo";

import Page from "../../../components/Page";
import WinItem from "../../../components/WinItem";
import {get_publication} from "../../../api/publication";
import {employee_list, get_employee_page} from "../../../api/employee";

const Container = styled.div`
  display: block;
  overflow: hidden;
  width: 100%;
  min-height: calc(100vh - 100px);
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  width: 90%;
  max-width: 910px;
  margin: 50px auto;
`;

const Title = styled.h1`
  text-align: center;
  margin: 0;
`;

const Link = styled.a`
  font-size: 14px;
  color: #a7a9ac;
  text-align: center;
  margin: 0;
`;

const Organizer = styled.h3`
  color: #a7a9ac;
  text-align: center;
  margin: 0;
`;

const ImageContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin: 2rem 0;
`;

const Image = styled.img`
  max-width: 400px;
`;

const Desc = styled.div`
  text-align: justify;
  margin-bottom: 40px;
  font-family: Verdana, Geneva, sans-serif;
`;

const Employees = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
`;

class PublicationPage extends React.Component {
  render() {
    return (
      <Page>
        <NextSeo
          title={this.props.publication.title}
          description={this.props.publication.title}
        />

        <Container>
          <Content>
            <Title>{this.props.publication.title}</Title>
            <Organizer>{this.props.publication.subtitle}</Organizer>
            <Link href={this.props.publication.link}>{this.props.publication.link}</Link>

            <ImageContainer>
              <Image
                src={this.props.publication.cover}
                alt={this.props.publication.title}
              />
            </ImageContainer>

            <Desc dangerouslySetInnerHTML={{__html: this.props.text}} />

            <Employees>
              {this.props.publication.project_set &&
                this.props.publication.project_set.map(win => (
                  <WinItem key={win.slug} win={win} />
                ))}
            </Employees>
          </Content>
        </Container>
      </Page>
    );
  }
}

export async function getServerSideProps(context) {
  try {
    const language = context.locale || "en";
    const {slug} = context.query;
    const publication = await get_publication(slug, language);

    if (publication.detail && publication.detail === "Not found.") {
      return {
        notFound: true,
      };
    }

    return {
      props: {
        publication,
      },
    };
  } catch (e) {
    console.log(e);
    return {
      notFound: true,
    };
  }
}

export default PublicationPage;
